import { useDirection } from '../direction';
export var usePlacement = placement => {
  var {
    isRTL
  } = useDirection();
  return placement.replace('leading', isRTL ? 'right' : 'left').replace('trailing', isRTL ? 'left' : 'right');
};